import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material"
import { PersianDatePicker } from "components/Common/PersianDatePicker"
import { initReport, serializeQuery } from "helpers/service_helper"
import { CityFromSection } from "hooks/returnCityName"
import { isNumber } from "lodash"
import React, { useState, useEffect, useReducer } from "react"

import { connect } from "react-redux"
import {
  getGasProjectReport,
  getGasProjects,
  getListExecutor,
  getListExecutorFilter,
} from "store/actions"

import StiReport from "../../../../assets/reports/GasProjectReport.mrt"
import StiGCityReport from "../../../../assets/reports/GasProjectGCityReport.mrt"
import Localizations from "../../../../locales/fa/fa.xml"

import Locations from "components/Common/Locations"

import { Checkbox, Col, Row } from "antd"
import { GetCityWithSection } from "../../../../hooks/returnCityName"
import { loadStimulsoftScripts } from "helpers/stimulsoftLoader"
const ExecutorList = props => {
  const { lstGasProjectReport, translate, loading } = props
  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(1000)
  const [page, setPage] = useState(0);
  const [dateRegister, setDateRegister] = useState("")
  const [filterCity, setFilterCity] = useState(false)
  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      projectLevelEnum: 1,
      groupReport:1,
      filterDate:1
    }
  )

    // Helper to ensure Stimulsoft scripts are loaded before using initReport
    const ensureStimulsoftAndInit = async (reportData, groupReport) => {
      await loadStimulsoftScripts()
  
      if(groupReport === 0)
      initReport(StiReport, reportData, Localizations)
      if(groupReport === 1)
      initReport(StiGCityReport, reportData, Localizations)

    }
  

  useEffect(() => {
    setTimeout(() => {
      setErrorMessage(null)
    }, 3000)
  }, [errorMessage])
  const handleInput = async evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (newValue == "on") newValue = evt.target.checked

    if (evt.target.attributes.type?.value === "text") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
    }
    if (evt.target.attributes.type?.value === "number") newValue = +newValue
    if (evt.target.attributes.type?.value === "radio") {
      if (newValue === "true" || newValue === "false")
        newValue = newValue === "true"
      if (isNumber(parseInt(newValue))) newValue = +newValue
    }

    setFormInput({ [name]: newValue })

  }
  useEffect(() => {
    // props.onGetListExecutor()
    if (lstGasProjectReport.length > 0) {
      const reportData = lstGasProjectReport.map(c => {
        return {
          ...c,
          exeFullName: c.executor.fullName,
          cityName: GetCityWithSection(c.idSection),
          address: c.address.split(":")[1],
        }
      })
      
      ensureStimulsoftAndInit(reportData, formInput.groupReport)

    }
  }, [lstGasProjectReport])

  // useEffect(async () => {

  //   await props.onGetGasProjectReport({
  //     projectLevelEnum: formInput.projectLevelEnum,
  //     registerDate: dateRegister.persian && formInput.filterDate === 0?dateRegister.persian:'',
  //   })
  // }, [formInput, dateRegister])

  const prepareReport = async ()=> {
    let searchQuery = {
      projectLevelEnum: formInput.projectLevelEnum,
      registerDate: dateRegister.persian && formInput.filterDate === 0?dateRegister.persian:'',
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      page,
      pageSize
    }
    const params = serializeQuery(searchQuery)
    await props.onGetGasProjectReport(params)
  }

  return (
    <>
      {props.loading && <CircularProgress disableShrink />}
      <Box>
        <Grid
          container
          justifyContent="center"
          spacing={1}
          alignItems="center"
        ></Grid>
              <Row>
            <Col>
              <Checkbox
                onChange={e => {
                  setFilterCity(e.target.checked)
                }}
              >
                فیلترشهر
              </Checkbox>
            </Col>
            {filterCity && (
              <Col className="gutter-row">
                <Locations
                  setDataAddress={setDataAddress}
                  matches_sm={true}
                  isAccessCity={true}
                />
              </Col>
            )}
            </Row>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="radio-consent-label"
              name="projectLevelEnum"
              value={formInput.projectLevelEnum}
              onChange={handleInput}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="تخصیص کارشناسی"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="تخصیص نقشه"
              />
              <FormControlLabel value={2} control={<Radio />} label="تایید واحد گاز" />
              <FormControlLabel value={3} control={<Radio />} label="تخصیص نقشه های رد شده" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="radio-consent-label"
              name="groupReport"
              value={formInput.groupReport}
              onChange={handleInput}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="گروه بندی مجری"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="گروه بندی شهر"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="radio-consent-label"
              name="filterDate"
              value={formInput.filterDate}
              onChange={handleInput}
            >
              <FormControlLabel
                value={0}
                control={<Radio />}
                label="با تاریخ"
              />
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="بدون تاریخ"
              />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <PersianDatePicker setPersianDate={setDateRegister} disable={false} />
        </Grid>
      </Box>
      <Button
        variant="contained"
        onClick={async () => {
          await prepareReport()
        }}
        type="submit"
      >
        گزارش گیری
      </Button>
      <Button
        variant="contained"
        onClick={async () => {
          await props.onGetGasProjectReport({
            projectLevelEnum: 0,
            registerDate: "",
          })
        }}
        type="submit"
      >
        حذف فیلتر
      </Button>


        {lstGasProjectReport.length > 0 && (
        <div style={{ maxWidth: "822px" }} id="viewer"></div>
      )}
    </>
  )
}

const mapStateToProps = ({ GasProjects }) => ({
  lstGasProjectReport: GasProjects.lstGasProjectReport,
  error: GasProjects.error,
  success: GasProjects.success,
  loading: GasProjects.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetGasProjectReport: values => dispatch(getGasProjectReport(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ExecutorList)
